/**
 * WordPress dependencies
 * @wordpress/i18n for translation functions
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 * - Should basically always be used for any text that is visible to the user
 *
 * @wordpress/element for React components
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-element/
 */
import { __ } from '@wordpress/i18n';
import { decodeEntities } from '@wordpress/html-entities';

import { handleEuneosRegisterClick, checkIfRegistrable } from '@utils';

import CourseRowItemVenue from './CourseRowItemVenue';
import CourseRowItemMealPackage from './CourseRowItemMealPackage';

/**
 * CourseListItem Component
 * @param {Object} props
 * @returns {JSX.Element}
 */
function CourseRowItem({
	id,
	start,
	end,
	status,
	venues,
	registrationUrl,
	forceSellProducts,
}) {
	const formatter = new Intl.DateTimeFormat('fi', {
		day: 'numeric',
		month: 'numeric',
		year: 'numeric',
	});

	const startDate = start ? formatter.format(new Date(start)) : 'On Demand';
	const endDate = end ? ' - ' + formatter.format(new Date(end)) : '';

	return (
		<tr className="upcoming-instances__row">
			<td>
				{startDate}
				{endDate}
			</td>
			<td>{decodeEntities(status[0]?.name)}</td>
			<td>
				{venues.map((venue, index) => (
					<CourseRowItemVenue
						key={`${venue?.id}-${venue?.slug}-${index}`}
						{...venue}
					/>
				))}
			</td>
			<td colSpan="2">
				{checkIfRegistrable({ status }) && (
					<a
						href={registrationUrl}
						target="_blank"
						rel="noopener noreferrer"
						data-track="true"
						data-track-event="link_click"
						data-track-action="register"
						data-track-label={id}
						onClick={() => handleEuneosRegisterClick(id)}
					>
						Register Now
					</a>
				)}
			</td>
			<td>
				{forceSellProducts.length !== 0 ? (
					<CourseRowItemMealPackage
						id={forceSellProducts[0].id}
						title={forceSellProducts[0].title}
						price={forceSellProducts[0].price}
					/>
				) : null}
			</td>
		</tr>
	);
}

export default CourseRowItem;
